import React from "react";
import {InlineHeartComp} from "../howIsItWorking/HowIsItWorking";
import ButtonComp from "../buttons/buttonComp/buttonComp";

const NewRegistryButton = () => {
    return (
        <ButtonComp fullWidth={true} backgroundColor={'#000000'} visible={false} textColor={true}>
            <React.Fragment>Ayda 90 bin Yeni Kayıt <InlineHeartComp marginCorrection={false}
                                                                    topCorrection={false}/> 15 yıldır yanınızda
            </React.Fragment>
        </ButtonComp>
    );
}

export default NewRegistryButton;
